<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected stand-division-section stand-division-section--form">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Selection.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Selection.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div class="zn-step-content-section-filters">
          <div class="form-control-container">
            <label class="form-label" for="standFusionStandSelect">
              {{ 'Planning::Entity.Stand' | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              #standSelect
              id="standFusionStandSelect"
              [optionsLoader]="standOptionsLoader"
              [showSearch]="true"
              [localizationResource]="localizationResource"
              [placeholder]="(localizationKeyPrefix + '.Selection.Placeholder') | abpLocalization"
              [openUp]="false"
              (selectedChange)="onStandChange($event)"
            ></zn-single-select>
          </div>
        </div>
        <div class="zn-step-content-section-actions">
          <zn-button
            type="primary"
            size="normal"
            iconLeft="bi bi-plus"
            loadingIconPosition="left"
            [label]="(localizationKeyPrefix + '.Selection.Add') | abpLocalization"
            [disabled]="addDisabled()"
            [loading]="loading()"
            (clicked)="addStand()"
          ></zn-button>
        </div>
      </div>
    </div>
  </div>

  <div class="zn-full-height zn-step-content-section stand-division-section stand-division-section--table">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Table.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Table.Description') | abpLocalization }}</p>
        </div>
        <div class="zn-summary-container">
          <div class="zn-summary-item">
            <p class="title">{{ (localizationKeyPrefix + '.Summary.Species') | abpLocalization }}</p>
            <p class="subtitle"><zn-pill [label]="displayValue(summarySpecies())"></zn-pill></p>
          </div>
          <div class="zn-summary-item">
            <p class="title">{{ (localizationKeyPrefix + '.Summary.LandContract') | abpLocalization }}</p>
            <p class="subtitle"><zn-pill [label]="displayValue(summaryLandContract())"></zn-pill></p>
          </div>
          <div class="zn-summary-item">
            <p class="title">{{ (localizationKeyPrefix + '.Summary.ForestContract') | abpLocalization }}</p>
            <p class="subtitle"><zn-pill [label]="displayValue(summaryForestContract())"></zn-pill></p>
          </div>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-table" [class.zn-table--empty]="selectedStands().length === 0">
        <div class="zn-table-scroll">
          <table class="zn-table-element">
            <thead>
              <tr>
                <th>{{ 'Planning::Entity.Stand' | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.StandArea') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.StandType') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.ForestrySituation') | abpLocalization }}</th>
                <th>{{ 'Geographic::Entity.Cycle' | abpLocalization }}</th>
                <th>{{ 'Geographic::Entity.Rotation' | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.RotationUse') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.PlantationDate') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.OwnPlantation') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.GeneticMaterial') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.Result') | abpLocalization }}</th>
              </tr>
            </thead>
            <tbody>
              @if (selectedStands().length === 0) {
                <tr>
                  <td class="zn-table-empty" colspan="11">
                    {{ (localizationKeyPrefix + '.Table.Empty') | abpLocalization }}
                  </td>
                </tr>
              }

              @for (row of selectedStands(); track row.backendId) {
                <tr [class.zn-row--original]="row.isPersistedStand">
                  <td>
                    <div class="zn-action-container">
                      <button
                        class="btn btn-tertiary btn-sm btn-delete"
                        type="button"
                        (click)="removeStand(row)"
                      >
                        <i class="bi bi-trash3"></i>
                      </button>
                      <span>{{ row.name }}</span>
                    </div>
                  </td>
                  <td>{{ formatArea(row.area) }}</td>
                  <td>{{ displayValue(row.standType) }}</td>
                  <td>{{ displayValue(row.forestrySituation) }}</td>
                  <td>{{ formatCycleLabel(row.cycle, row.isLastCycle) }}</td>
                  <td>{{ formatRotationLabel(row.rotation, row.isLastRotation) }}</td>
                  <td>{{ displayValue(row.rotationUse) }}</td>
                  <td>{{ displayValue(row.plantationDate) }}</td>
                  <td>{{ displayValue(row.ownPlantation) }}</td>
                  <td>{{ displayValue(row.geneticMaterial) }}</td>
                  <td>{{ rowResultLabelKey(row) | abpLocalization }}</td>
                </tr>
              }

              @if (selectedStands().length > 0) {
                <tr class="zn-resume">
                  <td>{{ (localizationKeyPrefix + '.Table.TotalArea') | abpLocalization }}</td>
                  <td>
                    <span class="zn-total-input">{{ formatArea(totalArea()) }}</span>
                  </td>
                  <td colspan="9"></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
